import { fetchAuthToken } from "app/Auth";
import Constants from "common/constant";
import { client } from "common/apiClient";

export type QrLoginSessionResponse = {
  code: string;
  session_secret: string;
  expires_in: number;
};

export type QrLoginPollResponse = {
  status: "pending" | "approved" | "expired";
  idToken?: string;
};

// 新端末（未ログイン）: QRログインセッションを作成する
export const createQrLoginSession = async () => {
  return client({ token: Constants.apiAuthKey }).post<QrLoginSessionResponse>(
    "/v1/sign/qr_login/session",
    { app: "parents" },
  );
};

// 新端末（未ログイン）: 秘密トークンで承認状態をポーリングする
export const pollQrLogin = async ({ session_secret }: { session_secret: string }) => {
  return client({ token: Constants.apiAuthKey }).post<QrLoginPollResponse>(
    "/v1/sign/qr_login/poll",
    { session_secret },
  );
};

// ログイン済みの保護者端末: 承認前にコードのリクエスト元アプリを取得する
export const getQrLoginSessionInfo = async ({ code }: { code: string }) => {
  const token = await fetchAuthToken();
  return client({ token }).post<{ app: "kids" | "parents" }>("/v1/qr_login/info", { code });
};

// ログイン済みの保護者端末: 新端末のコードを承認する
export const approveQrLogin = async ({ code }: { code: string }) => {
  const token = await fetchAuthToken();
  return client({ token }).post<{ status: string }>("/v1/qr_login/approve", { code });
};
